/**
 * Detects Terms-of-Service / safety moderation errors from API messages and flags.
 * Keep in sync with supabase/functions/generation and stream NDJSON `tos_violation`.
 */
export function isTosViolationMessage(
  message: string | null | undefined,
  explicitFlag?: boolean
): boolean {
  if (explicitFlag) return true
  if (!message) return false
  const lower = message.toLowerCase()
  if (lower.includes("was flagged")) return true
  if (lower.includes("this prompt violates")) return true
  if (lower.includes("violates our terms of service")) return true
  if (lower.includes("violate our terms of service")) return true
  if (
    lower.includes("terms of service") &&
    (lower.includes("violate") || lower.includes("violation"))
  ) {
    return true
  }
  return false
}
